import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('stripe-payment', (editor, opts = {}) => {
  let c = opts;
  const default_types = {
    stripePaymentButton: 'stripe-payment',
  };
  const default_labels = {
    stripePaymentButton: 'Pay',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Payment Gateway',
    },
    ...opts,
  };
  console.log('Stripe Payments opts :>> ', opts, 'options', options);
  for (let name in options) {
    if (!(name in c)) c[name] = options[name];
  }

  console.log('Stripe Payments opts :>> ', opts);

  loadComponents(editor, opts);
});
